// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.502Z

const holidays = {
  message: `Heads up: Our customer-facing teams are in annual training this week (April 6–10). Call scheduling is paused and messaging may be slower than usual. Normal availability resumes April 13.`,
  dates: [`4/6/2026`, `4/7/2026`, `4/8/2026`, `4/9/2026`, `4/10/2026`],
  bannerDates: [`4/6/2026`, `4/7/2026`, `4/8/2026`, `4/9/2026`, `4/10/2026`],
} as const;

export default holidays;
